import { Prop, Component, Vue } from 'vue-facing-decorator'
import ClientLogo from '@/components/core/logo/ClientLogo.vue'

@Component({
  components: { ClientLogo },
})
export default class LoadingScreenComponent extends Vue {
  @Prop className: string | undefined

  mounted() {
    //
  }
}
